module.exports = __webpack_public_path__ + "media/images/icons/external-link-b213a237977d46c2db0c59bb66640d58.svg";